<app-dialog-container class="pdf-viewer-container">
    <div class="viewer-header" fxLayout="row"
        fxLayoutAlign="space-between center">
        <h2 mat-dialog-title fxLayout="row" fxLayoutAlign="center center">
            <mat-icon class="header-icon">description</mat-icon>
            Visualizar Contrato
            <span *ngIf="isPreviewMode" class="preview-badge">
                PRÉVIA
            </span>
        </h2>
        <div fxLayout="row" fxLayoutAlign="center center" fxLayoutGap="12px">
            <button *ngIf="canDownload" mat-raised-button
                class="download-button"
                (click)="downloadContract()" [disabled]="loading || error"
                matTooltip="Baixar contrato"
                fxLayout="row" fxLayoutAlign="center center" fxLayoutGap="6px">
                <mat-icon>download</mat-icon>
                BAIXAR
            </button>
            <button mat-stroked-button color="warn" (click)="close()">
                <mat-icon>close</mat-icon>
                Fechar
            </button>
        </div>
    </div>

    <mat-divider></mat-divider>

    <!-- Mensagem de modo preview -->
    <div *ngIf="isPreviewMode && previewMessage" class="preview-message">
        <mat-icon>visibility</mat-icon>
        {{ previewMessage }}
    </div>

    <!-- Mensagem de processamento -->
    <div *ngIf="processingMessage" class="processing-message">
        <mat-icon>hourglass_empty</mat-icon>
        {{ processingMessage }}
    </div>

    <div class="viewer-content">
        <!-- Loading State -->
        <div *ngIf="loading" class="loading-container" fxLayout="column"
            fxLayoutAlign="center center">
            <mat-spinner diameter="40"></mat-spinner>
            <p>Carregando contrato...</p>
        </div>

        <!-- Error State -->
        <div *ngIf="error || zapSignError" class="error-container"
            fxLayout="column"
            fxLayoutAlign="center center">
            <mat-icon class="error-icon"
                [ngClass]="{'warning-icon': isPreviewMode && contract?.status !== 'signed'}">
                {{ isPreviewMode && contract?.status !== 'signed' ?
                'hourglass_empty' : 'error_outline' }}
            </mat-icon>
            <h3>{{
                isPreviewMode && contract?.status !== 'signed' ?
                'Documento em processamento' :
                (error ? 'Erro ao carregar contrato' :
                'Erro na visualização ZapSign')
                }}</h3>

            <!-- Documento em processamento (Preview) -->
            <p *ngIf="isPreviewMode && contract?.status !== 'signed'">
                O documento ainda está sendo preparado. Este processo geralmente
                leva apenas alguns minutos.
                A página será atualizada automaticamente quando o documento
                estiver pronto.
            </p>

            <!-- Erro geral -->
            <p
                *ngIf="error && !(isPreviewMode && contract?.status !== 'signed')">
                Não foi possível carregar o documento. Por favor, tente
                novamente.
            </p>

            <!-- Erro ZapSign -->
            <p *ngIf="zapSignError && contract?.status === 'processing'">
                O documento ainda está sendo processado pela ZapSign.
                A página será atualizada automaticamente quando estiver
                disponível.
            </p>
            <p *ngIf="zapSignError && contract?.status !== 'processing'">
                Não foi possível carregar o contrato da ZapSign.
                Tente novamente mais tarde ou entre em contato com o suporte.
            </p>

            <button mat-raised-button color="primary"
                (click)="refreshContractData()">
                <mat-icon>refresh</mat-icon>
                Tentar novamente
            </button>
        </div>

        <!-- ZapSign Viewer -->
        <div
            *ngIf="!loading && !error && !zapSignError && isZapSign && zapSignUrl"
            class="iframe-container document-container" fxFlex="1 1 auto">
            <iframe
                [src]="zapSignUrl"
                class="pdf-viewer"
                frameborder="0"
                sandbox="allow-same-origin allow-scripts allow-popups allow-forms"
                allowfullscreen>
            </iframe>
        </div>

        <!-- PDF Viewer (Fallback) -->
        <div *ngIf="!loading && !error && !zapSignError && !isZapSign && pdfUrl"
            class="iframe-container document-container" fxFlex="1 1 auto">
            <iframe
                [src]="pdfUrl"
                class="pdf-viewer"
                frameborder="0"
                allowfullscreen>
            </iframe>
        </div>

        <!-- Mensagem quando não há conteúdo para exibir -->
        <div
            *ngIf="!loading && !error && !zapSignError && !isZapSign && !pdfUrl && !zapSignUrl && !processingMessage"
            class="no-content-container" fxLayout="column"
            fxLayoutAlign="center center">
            <mat-icon class="no-content-icon">visibility_off</mat-icon>
            <h3>Nenhum conteúdo disponível</h3>
            <p>Não foi possível carregar o conteúdo do contrato.</p>
            <button mat-raised-button color="primary"
                (click)="refreshContractData()">
                <mat-icon>refresh</mat-icon>
                Tentar novamente
            </button>
        </div>
    </div>

    <!-- Botão para ir para o fim do documento -->
    <div *ngIf="!loading && !error && !zapSignError && (pdfUrl || zapSignUrl)"
        class="scroll-controls">
        <button mat-fab color="primary" class="scroll-button"
            (click)="scrollToBottom()"
            matTooltip="Ir para o final do documento">
            <mat-icon>keyboard_arrow_down</mat-icon>
        </button>
    </div>
</app-dialog-container>
